'use client';

import { useCallback, useEffect, useState } from 'react';

import { listGuestOrders, type GuestOrderRecord } from '@/lib/customer/guest-orders';

/**
 * The guest's own order history for this device, kept in sync with the storage
 * events that mutate it.
 *
 * Lives here rather than beside the sheet that renders it because the PLACE
 * CHROME needs the same answer: the header shows an Orders control with a count
 * on it, and importing the whole orders sheet into the shell to get one number
 * would pull the table bill, the account fetch and the realtime status hook into
 * every menu render.
 */
export function useGuestOrderRecords(): GuestOrderRecord[] {
  const [records, setRecords] = useState<GuestOrderRecord[]>([]);
  const refresh = useCallback(() => setRecords(listGuestOrders()), []);

  useEffect(() => {
    refresh();
    const onChange = () => refresh();
    window.addEventListener('mnrq:guest-orders-changed', onChange);
    window.addEventListener('storage', onChange);
    return () => {
      window.removeEventListener('mnrq:guest-orders-changed', onChange);
      window.removeEventListener('storage', onChange);
    };
  }, [refresh]);

  return records;
}
